import scrollToElement from 'scroll-to-element';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    /* ------------------------------------*\
        ANCHOR
    \*------------------------------------*/

    [].forEach.call(document.querySelectorAll('a[data-anchor]'), (anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            if (typeof (anchor) !== 'undefined' && anchor != null) {
                e.preventDefault();
                const target = anchor.getAttribute('href');

                scrollToElement(document.querySelector(target), {
                    offset: -100,
                    duration: 500,
                });
            }
        });
    });
}));